import type { PageAction } from "@/app/pageActions/PageActionsContext";
import {
  resolveActionIcon,
  resolveActionLabel,
} from "@/shared/lib/actionIcons";

export { PAGE_ACTION_ICONS } from "@/shared/lib/actionIcons";

export function resolvePageActionIcon(
  action: PageAction,
  className = "size-4 shrink-0",
) {
  return resolveActionIcon(action.id, action.iconKey, className);
}

export function resolvePageActionLabel(action: PageAction): string {
  return action.label || resolveActionLabel(action.id, action.label);
}

export function resolvePageActionTitle(action: PageAction): string {
  return action.title ?? action.label;
}
